//libraries
import {FC} from 'react';

import {DialogProps} from '@mui/material';
import Dialog from '@mui/material/Dialog';

import {defaultModalStyle} from './styles';

export type MuiModalProps = DialogProps;

const MuiModal: FC<MuiModalProps> = ({children, ...rest}) => {
  return (
    <Dialog sx={defaultModalStyle} {...rest}>
      {' '}
      {children}{' '}
    </Dialog>
  );
};

export default MuiModal;
